/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconYoujiantou: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M369.418654 860.570837c-12.671601 0-25.343201-4.836145-35.016515-14.509459-19.346627-19.346627-19.346627-50.687426 0-70.03303l259.432681-259.360026L325.115636 247.972675c-19.346627-19.346627-19.346627-50.687426 0-70.03303s50.687426-19.346627 70.03303 0l303.735699 303.71114c9.286504 9.286504 14.509459 21.88545 14.509459 35.016515 0 13.131065-5.223978 25.730011-14.509459 35.016515L404.435169 846.060355C394.761855 855.733669 382.090255 860.570837 369.418654 860.570837z"
        fill={getIconColor(color, 0, '#595757')}
      />
    </svg>
  );
};

IconYoujiantou.defaultProps = {
  size: 18,
};

export default IconYoujiantou;
